"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _List = _interopRequireDefault(require("@mui/material/List/List.js"));
var _ListItem = _interopRequireDefault(require("@mui/material/ListItem/ListItem.js"));
var _ListItemIcon = _interopRequireDefault(require("@mui/material/ListItemIcon/ListItemIcon.js"));
var _ListItemText = _interopRequireDefault(require("@mui/material/ListItemText/ListItemText.js"));
var _react = _interopRequireWildcard(require("react"));
var _aggregationOptions = require("./aggregationOptions");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = /*#__PURE__*/(0, _react.forwardRef)(({
  value,
  onChange,
  options = _aggregationOptions.defaultAggregations
}, ref) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_List.default, {
    ref: ref,
    children: options.map(aggregation => {
      const {
        Icon,
        label
      } = _aggregationOptions.aggregationDetailDictionary[aggregation];
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_ListItem.default, {
        button: true,
        selected: aggregation === value,
        onClick: e => onChange(e, aggregation),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemIcon.default, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, {})
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemText.default, {
          children: label
        })]
      }, aggregation);
    })
  });
});